import axios from "axios";
export const addUser = (body:any) =>
    axios.post(`https://gn5mla6ofe.execute-api.us-east-2.amazonaws.com/haribo/user`,body);